@use '../@shared/kol-select-mixin' as *;

@layer kol-component {
	@include kol-select;
}
